// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__gAPae","modalFooterButton":"ModalNotes_modalFooterButton__3biyO"};